export default class DeletedRecordError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "DeletedRecordError";

    Object.setPrototypeOf(this, DeletedRecordError.prototype);
  }
}
